import Vue from 'vue'
import _ from 'lodash'
import * as dateFns from 'date-fns'
import * as RoutePage from '@/constants/route-page'
import * as Constants from '@/constants'
import Utils from '@/utils'

import { Message } from 'element-ui'

Vue.prototype.$routePage = RoutePage
Vue.prototype.Constants = Constants
Vue.prototype.Utils = Utils
Vue.prototype.$_ = _
Vue.prototype.$date = dateFns
// Vue.prototype.$liff = liff
Vue.prototype.$alert = (...arg) => {
  Message.closeAll()
  Message(...arg)
}
Vue.config.productionTip = false
